"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThemeProvider = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = require("styled-components");
const base_1 = require("../design/themes/base");
const utils_1 = require("../design/utils");
const DesignSystem_1 = require("../DesignSystem");
const themeConverter_1 = require("../DesignSystem/helpers/themeConverter");
const helpers_1 = require("../helpers");
const THEME = __importStar(require("../themes/colors"));
const GlobalStyles = (0, styled_components_1.createGlobalStyle) `
    [${helpers_1.CLASS_DIALOG_MOVING_ATTR_NAME}] {
        cursor: move;
    }

    [${helpers_1.CLASS_MODAL_INERT_ATTR_NAME}] {
        pointer-events: none;
        cursor: default;
    }

    [${helpers_1.CLASS_MODAL_INERT_ATTR_NAME}], [${helpers_1.CLASS_MODAL_INERT_ATTR_NAME}] * {
        user-select: none;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
    }
`;
const ThemeProvider = ({ theme = THEME.blue, children, parentRef }) => {
    if (theme === null || theme === void 0 ? void 0 : theme.newTheme) {
        document.styleSheets.item(0).insertRule(`:root { ${(0, utils_1.defineCSSVars)(window.baseTheme || base_1.baseTheme, theme === null || theme === void 0 ? void 0 : theme.newTheme)} }`);
    }
    const newTheme = (0, react_1.useMemo)(() => (0, themeConverter_1.themeConverter)(theme), [theme]);
    return (react_1.default.createElement(DesignSystem_1.ThemeProviderNew, { theme: newTheme, parentRef: parentRef },
        react_1.default.createElement(styled_components_1.ThemeProvider, { theme: theme },
            react_1.default.createElement(GlobalStyles, null),
            children)));
};
exports.ThemeProvider = ThemeProvider;
//# sourceMappingURL=ThemeProvider.js.map